import { RoutePath } from '@core/types/route';
import { MenuItem } from '@homepage/types/menu';

import { COMPANY } from './company';

export const MENU: MenuItem[] = [
  { href: RoutePath.Home, text: 'Start' },
  { href: RoutePath.KampfkunstTraining, text: 'Training' },
  { href: RoutePath.Kontakt, text: 'Kontakt' },
  { href: 'https://shop.systema-berlin.de', text: 'Shop' },
  { href: `tel:${COMPANY.phone}`, showDesktop: false, text: COMPANY.phoneText },
];
